import React from 'react';

const AdvancedServices = () => {
  return (
    <svg width='121' height='120' viewBox='0 0 121 120' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M100.883 35.164a2.2 2.2 0 0 1 1.779.375l13.009 9.553.174.142a2.2 2.2 0 0 1-2.591 3.529l-.187-.124-8.493-6.239c9.555 23.663-1.432 50.771-24.973 61.018-12.856 5.596-26.845 5.024-38.648-.41l-.56-.263-.197-.106a2.2 2.2 0 0 1 1.882-3.953l.207.086 1.021.47c10.602 4.715 23.065 5.135 34.538.142 21.457-9.34 31.414-34.125 22.517-55.66l-4.814 8.804-.117.192a2.2 2.2 0 0 1-3.742-2.303l7.742-14.16.125-.202a2.2 2.2 0 0 1 1.328-.89zM41.079 16.7c13.06-5.684 27.289-5.003 39.208.673a2.2 2.2 0 0 1-1.892 3.973c-10.818-5.152-23.715-5.766-35.559-.612-21.51 9.364-31.462 34.248-22.448 55.822l5.062-9.26.117-.19a2.2 2.2 0 0 1 3.742 2.302l-7.742 14.16-.124.203a2.202 2.202 0 0 1-3.109.515L5.327 74.732l-.174-.142a2.2 2.2 0 0 1 2.59-3.529l.188.124 7.884 5.792C6.78 53.49 17.784 26.84 41.079 16.699z'
        fill='#000'
      />
      <rect
        x='46.5'
        y='84'
        width='48'
        height='28'
        rx='2.719'
        transform='rotate(-90 46.5 84)'
        stroke='var(--theme-primary, #810ea9)'
        strokeWidth='4.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <circle cx='60.5' cy='75.8' r='2.2' transform='rotate(-180 60.5 75.8)' fill='var(--theme-primary, #810ea9)' />
    </svg>
  );
};

export default AdvancedServices;
